import { Stack } from '@mui/material';
import useRecordAttendanceDrawerForm, { UseRecordAttendanceDrawerForm } from './vm';
import { Content, DrawerButton } from './styled';
import { useTranslation } from 'react-i18next';
import { i18nNS } from '../../../../../../../../i18n';
import AttendanceDataSkeleton from './AttendanceDataSkeleton';
import InSessionAttendance from './InSessionAttendance';
import NextScheduledAttendance from './NextScheduledAttendance';

export interface RecordAttendanceDrawerFormProps extends UseRecordAttendanceDrawerForm {
  className?: string;
}

const RecordAttendanceDrawerForm = ({ className, ...vmProps }: RecordAttendanceDrawerFormProps) => {
  const { t } = useTranslation([i18nNS.GLOSSARY]);
  const {
    onClose,
    formMethods,
    onSubmit,
    isFetchingAttendanceData,
    inSessionAttendanceData,
    nextScheduledAttendanceData,
  } = useRecordAttendanceDrawerForm(vmProps);

  const { handleSubmit, control, formState } = formMethods;
  const { isValid, isSubmitting } = formState;

  return (
    <Stack gap={2} component="form" noValidate onSubmit={handleSubmit(onSubmit)}>
      <Content>
        {isFetchingAttendanceData ? (
          <AttendanceDataSkeleton />
        ) : inSessionAttendanceData.length !== 0 ? (
          <InSessionAttendance
            control={control}
            name="selectedClassId"
            inSessionAttendanceData={inSessionAttendanceData}
          />
        ) : (
          <NextScheduledAttendance
            control={control}
            name="selectedClassId"
            nextScheduledAttendanceData={nextScheduledAttendanceData}
          />
        )}
      </Content>
      <Stack direction="row" justifyContent="flex-end" alignItems="center" gap={2} component="footer">
        <DrawerButton type="button" variant="text" onClick={onClose}>
          {t('cancel', { ns: i18nNS.GLOSSARY })}
        </DrawerButton>
        <DrawerButton type="submit" isLoading={isSubmitting} disabled={!isValid || isSubmitting}>
          {t('start', { ns: i18nNS.GLOSSARY })}
        </DrawerButton>
      </Stack>
    </Stack>
  );
};

export default RecordAttendanceDrawerForm;
